import React from "react";
import styles from './SideBar.module.sass'
import PropTypes from 'prop-types'
import homeSVG from './Icons/homeIcon.svg'
import phoneSVG from './Icons/phoneIcon.svg'
import shieldSVG from './Icons/shieldIcon.svg'
import inforamtionSVG from './Icons/informationIcon.svg'
import logSVG from './Icons/logo.svg'


SideBar.defaultProps = {
    mainLogo: {
        icon: logSVG,
        href: '/',
        name: 'MeD-I'
    },

    model: [
        {text: 'Главная', href: '/', icon: homeSVG},
        {text: <>Проверка <br/> результатов</>, href: '/checkResult', icon: shieldSVG},
        {text: 'Контакты', href: '/contacts', icon: phoneSVG},
        {text: 'Обращение', href: '/appeal', icon: inforamtionSVG},
    ]
}

SideBar.propTypes = {
    mobile: PropTypes.bool,
    mainLogo: PropTypes.shape({
        name: PropTypes.string,
        href: PropTypes.string,
        icon: PropTypes.any
    }),
    model: PropTypes.arrayOf(
        PropTypes.shape({
            href: PropTypes.string,
            text: PropTypes.any,
            icon: PropTypes.any
        })).isRequired
}

function SideBar(props) {
    const mobile = props.mobile || false

    return (
        <div className={mobile ? styles.menuMobile : styles.menu}>
            <div className={styles.logo}>
                <a className={styles.logoLink} href={props.roleId === 5 ? "https://profdoctor.net/" :  props.mainLogo.href}>
                    <img className={styles.svg} src={props.mainLogo.icon} alt={props.mainLogo.name}/>
                    <span className={styles.logoText}>{props.mainLogo.name}</span>
                </a>
            </div>

            <ul className={styles.sidebarNav}>
                {props.model.map(option => <SideBarOption key={option.text + option.href} {...option} href={props.roleId === 5 ? "https://profdoctor.net/" : option.href} />)}
            </ul>
        </div>
    )
}

function SideBarOption({icon, text, href}) {
    return (
        <li key={text + href} className={styles.navItem}>
            <a className={styles.navLink} href={href}>
                <img className={styles.svg} src={icon} alt={text}/>
                <span className={styles.linkText}>{text}</span>
            </a>
        </li>
    )
}

export default SideBar